var map = {
	"./add-error.svg": 871,
	"./android.svg": 872,
	"./apple.svg": 873,
	"./arrow.svg": 874,
	"./close-thin.svg": 875,
	"./close.svg": 876,
	"./demo-picture.svg": 877,
	"./drag-icon.svg": 878,
	"./error.svg": 879,
	"./fair.svg": 880,
	"./feedback.svg": 881,
	"./highlight.svg": 882,
	"./hint.svg": 883,
	"./orange-sticker.svg": 884,
	"./paid.svg": 885,
	"./premium.svg": 886,
	"./rotate.svg": 887,
	"./success.svg": 888,
	"./top3-transparent.svg": 889,
	"./top3.svg": 890,
	"./valid.svg": 891,
	"./warning-black.svg": 892,
	"./warning.svg": 893,
	"./wp.svg": 894,
	"./zoom.svg": 895
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 870;



//////////////////
// WEBPACK FOOTER
// ./~/@cian/ui/app/components/icon/icons nonrecursive \.svg$
// module id = 870
// module chunks = 0